import { MaterialColors } from "../../helpers/Colors";
import { ChartDataSets } from "chart.js";
import {
  GetAlarmsApiResponse,
  GetAlarmsPerTypeApiResponse,
  GetAvailabilityEvolutionApiResponse,
} from "../../api/DetectionsRequests";

export const getStatusEvolutionDataset = (
  data: GetAvailabilityEvolutionApiResponse
) => {
  const labels: Array<string> = new Array<string>();
  const datasets = Array<ChartDataSets>();

  const dates: Array<Date> = new Array<Date>();

  data.map((device) => {
    datasets.push({
      lineTension: 0,
      borderColor: MaterialColors[datasets.length + 1] + "66",
      fill: false,
      label: device.hostname,
      data: device.data.map((it) => {
        return {
          x: new Date(it.date),
          y: it.online ? 1 : 0,
        };
      }),
    });
  });

  return {
    datasets: datasets,
    dates: [],
    error: undefined,
    labels: labels,
    maxValue: undefined,
  };
};
